module.exports = __webpack_public_path__ + "static/media/api-flat.704ec940.png";